/**
 * Company: SPHMedia
 * Description: [Renders podcast component]
 */

import AudioPlayer from "@elements/Player/PodcastPlayer";
import Heading from "@elements/Typography/Heading";
import { PodcastProcessedResponse } from "@hooks/transformer/usePodcastResponse";
import { ReactElement, RefObject } from "react";

type LongFormVideoProps = {
  playing: PodcastProcessedResponse;
  containerRef: RefObject<HTMLDivElement>;
};

/**
 * Media content podcast
 * Description: [Podcast player for article infinite scroll]
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export default function LongFormVideo({
  playing,
}: LongFormVideoProps): ReactElement {
  return (
    <div className="flex flex-col gap-3">
      <div className="mt-4 lg:mt-6 w-full h-0.5 bg-blue-400"></div>
      <Heading
        Element="h2"
        className="text-black-700 text-sm font-semibold leading-[150%]"
      >
        Podcast
      </Heading>
      <div className="-my-2">
        <AudioPlayer
          {...playing}
          height="200"
          showName={false}
          showDate={false}
        />
      </div>
    </div>
  );
}
